import styled from 'styled-components';

export const ShowcaseConfigurationDefaultBox = styled.div`
    flex-grow: 1;
    border: 1px dashed ${({theme}) => theme.colors.text};
    padding: 4px;

    input[type="text"] {
        width: 100%;
    }
`;